import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { default as ScrollLock } from 'react-scrolllock';
import { useModalCloseEvents } from './ModalOverlay.hooks.js';
import { ModalWrapper, Overlay } from './ModalOverlay.styled.js';
import { InternalModalContext } from '../context.js';
export const ModalOverlay = ({ children, className, onClose, closeOnEsc, closeOnOutsideClick, wrapperPadding, ...rest }) => {
    const modalRef = useRef(null);
    const overlayRef = useRef(null);
    const internalContext = useMemo(() => ({ onClose }), [onClose]);
    const { onOverlayClick } = useModalCloseEvents(onClose, closeOnEsc, closeOnOutsideClick, modalRef, overlayRef);
    return (_jsx(InternalModalContext.Provider, { value: internalContext, children: _jsx(Overlay, { ...rest, className: className, ref: overlayRef, onClick: onOverlayClick, children: _jsxs(ModalWrapper, { ref: modalRef, wrapperPadding: wrapperPadding, children: [_jsx(ScrollLock, {}), children] }) }) }));
};
